// ============================================================
// LegendaClassificacao.js — Legenda das 5 faixas de classificação
//
// Fonte única da legenda visual (cores + intervalos), usada na aba
// Relatórios (coordenadores), na tela do Técnico e na Área do Atleta.
// Os intervalos vêm da mesma régua do classificar() em calculo.js:
//   Muito bom 90–100 · Bom 80–89 · Regular 70–79 ·
//   Ruim 50–69 · Muito ruim 0–49 (sobre o % Total).
//
// Com a prop `comAcoes`, exibe também as ações previstas pelo programa
// para cada nível de frequência (regras de auxílio financeiro) — usada
// nas telas do atleta e do técnico, para transparência total.
// ============================================================

import { classificar, FAIXAS_REFERENCIA } from "../calculo";
import { argbParaCss, CINZA_ESC, TEXTO } from "../tema";

// Mensagem curta exibida ao atleta no topo da tela, conforme a faixa da
// sua frequência no mês. Fonte única — o rótulo bate com classificar().
export const MENSAGEM_POR_FAIXA = {
  "🌟 Muito bom": { tom: "ok", texto: "Parabéns! Sua frequência está excelente, continue nesse ritmo. 👏" },
  "✔ Bom": { tom: "ok", texto: "Boa frequência! Um pouco mais de constância e você chega ao nível máximo." },
  "⚠ Regular": { tom: "alerta", texto: "Atenção: sua frequência está no limite. Abaixo de 80% você fica fora da seleção para apoio financeiro em eventos." },
  "🔻 Ruim": { tom: "perigo", texto: "Alerta: neste nível seu auxílio será suspenso, e caso se repita você será desligado. Procure seu coordenador imediatamente." },
  "⛔ Muito ruim": { tom: "perigo", texto: "Situação crítica: sua bolsa será suspensa e você será desligado. Procure seu coordenador imediatamente." },
};

export const INTERVALOS_FAIXA = {
  "🌟 Muito bom": "90–100%",
  "✔ Bom": "80–89%",
  "⚠ Regular": "70–79%",
  "🔻 Ruim": "50–69%",
  "⛔ Muito ruim": "0–49%",
};

// Ações previstas pelo programa por nível de frequência, avaliadas até a
// 3ª semana de cada mês. Texto oficial — qualquer mudança de regra deve
// ser feita AQUI (fonte única das telas do atleta e do técnico).
const ACOES_PROGRAMA = [
  "Se a sua frequência ficar abaixo de 80%, você não poderá ser escolhido para receber ajuda financeira do programa para participar de eventos e competições.",
  "Se você ficar na faixa Regular (70% a 79%) até a 3ª semana do mês, você recebe uma advertência. Se isso se repetir por 2 meses seguidos, o auxílio é cancelado e você sai do programa.",
  "Se você ficar na faixa Ruim (50% a 69%) até a 3ª semana do mês, o seu auxílio fica suspenso. Se isso se repetir por 1 mês, você sai do programa.",
  "Se você ficar na faixa Muito ruim (abaixo de 49%) até a 3ª semana do mês, o auxílio é cancelado e você sai do programa.",
];

export default function LegendaClassificacao({ comAcoes = false }) {
  return (
    <div>
      <div style={{ fontSize: 12, fontWeight: 700, color: CINZA_ESC, marginBottom: 8, textAlign: "center" }}>
        Legenda das classificações
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 8, justifyContent: "center" }}>
        {FAIXAS_REFERENCIA.map(f => {
          const cls = classificar(f.ref);
          return (
            <div key={f.label} style={{
              display: "flex", alignItems: "center", gap: 6,
              background: argbParaCss(cls.bg), borderRadius: 20, padding: "5px 12px",
            }}>
              <span style={{ fontSize: 12, fontWeight: 700, color: argbParaCss(cls.cor) }}>{f.label}</span>
              <span style={{ fontSize: 11.5, color: argbParaCss(cls.cor) }}>{INTERVALOS_FAIXA[f.label]}</span>
            </div>
          );
        })}
      </div>

      {comAcoes && (
        <div style={{ marginTop: 16 }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: CINZA_ESC, marginBottom: 8 }}>
            Ações previstas pelo programa
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {ACOES_PROGRAMA.map((texto, i) => (
              <div key={i} style={{ fontSize: 12.5, color: TEXTO, lineHeight: 1.6 }}>
                {texto}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
